import React from "react";
// import Navbar from "react-bootstrap/Navbar";
import { useIsAuthenticated } from "@azure/msal-react";
import { SignInButton } from "./SignInButton";
import { SignOutButton } from "./SignOutButton";

/**
 * Renders the navbar component with a sign-in button if a user is not authenticated
 */
export const Button = () => {
    const isAuthenticated = useIsAuthenticated();

    return (
        <>
                {/* <a className="navbar-brand" href="/">MSAL React Tutorial</a> */}
                { isAuthenticated ? <SignOutButton /> : <SignInButton /> }
           
            
        </>
    );
};